export default Object.freeze({
  autoRefreshData: 'dashboard.autoRefreshData',
});
